// @flow

import React from 'react';

import styles from './popover.scss';

type Props = {
  children?: React.Node,
  showPopover: boolean
};

const Popover = (props: Props) =>
  props.showPopover ? (
    <div className={`${styles.popupWrapper}`}>
      <div className={`${styles.popupComponent}`}>{props.children}</div>
    </div>
  ) : null;

Popover.defaultProps = {
  children: ''
};

export default Popover;
